import { API_ENDPOINTS } from "@/constants/api";

export type ApprovalStatus = "pending" | "approved";

export async function getAccountApprovalStatus(): Promise<ApprovalStatus> {
  const response = await fetch(API_ENDPOINTS.AUTH.ACCOUNT_STATUS, {
    credentials: "include",
    headers: { Accept: "application/json" },
  });
  const body = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(
      (body as { error?: string }).error || "Unable to load account status"
    );
  }

  const status = (body as { data?: { approvalStatus?: unknown } }).data
    ?.approvalStatus;
  if (status !== "pending" && status !== "approved") {
    throw new Error("The account status response was invalid");
  }

  return status;
}
